<template>
  <v-row>
    <v-dialog
      v-model="show"
      persistent
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          :color="options.color"
          dense
          flat
        >
          <v-toolbar-title
            v-if="action === 'add'"
            class="white--text"
          >
            {{ add }}
          </v-toolbar-title>
          <v-toolbar-title
            v-if="action === 'edit'"
            class="white--text"
          >
            {{ edit }}
            <v-btn
              icon
              @click="removeEvent(event)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          v-model="valid"
          class="event-text"
        >
          <v-form
            ref="form"
            lazy-validation
          >
            <v-select
              v-model="event.project"
              :items="projects"
              item-text="name"
              item-value="pk"
              :rules="[v => !!v || 'Project is required']"
              label="Project"
              required
            />

            <v-text-field
              v-model="event.title"
              label="Title"
              :rules="[v => !!v || 'Title is required']"
              required
            />

            <v-row class="description">
              <v-textarea
                v-model="event.description"
                rows="1"
                auto-grow
                label="Description"
                :rules="[v => !!v || 'Description is required']"
                required
              />
            </v-row>

            <v-text-field
              v-model="event.location"
              label="Location"
              prepend-icon="location_on"
              :rules="[v => !!v || 'Location is required']"
              required
            />

            <v-switch
              v-model="multiDay"
              label="Multi-day event?"
            />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :disabled="action === 'add'"
                  :close-on-content-click="false"
                  :return-value.sync="selectedDate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="selectedDate"
                      readonly
                      label="Start Date"
                      prepend-icon="event"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="selectedDate"
                    no-title
                    scrollable
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="menuStartDate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuStartDate.save(selectedDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                v-if="multiDay"
                cols="12"
                sm="6"
                md="6"
              >
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  :return-value.sync="endDate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      label="End Date"
                      prepend-icon="event"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    no-title
                    scrollable
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="menuEndDate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuEndDate.save(endDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-menu
                  ref="menuStartTime"
                  v-model="menuStartTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.start_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="event.start_time"
                      label="Start time"
                      :rules="[v => !!v || 'Start time is required']"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="menuStartTime"
                    v-model="event.start_time"
                    no-title
                    :max="event.end_time"
                    @click:minute="$refs.menuStartTime.save(event.start_time)"
                  />
                </v-menu>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-menu
                  ref="menuEndTime"
                  v-model="menuEndTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.end_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="event.end_time"
                      label="End time"
                      :rules="[v => !!v || 'End time is required']"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="menuEndTime"
                    v-model="event.end_time"
                    no-title
                    :min="event.start_time"
                    @click:minute="$refs.menuEndTime.save(event.end_time)"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            v-if="action === 'edit'"
            color="primary darken-1"
            text
            @click.native="update(event)"
          >
            Update
          </v-btn>
          <v-btn
            v-if="action === 'add'"
            color="primary darken-1"
            text
            @click.native="submit(event)"
          >
            Submit
          </v-btn>
          <v-btn
            color="grey"
            text
            @click.native="cancel"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      ref="confirm"
      :close-form="cancel"
    />
  </v-row>
</template>

<style scoped></style>

<script>
import { mapState, mapActions } from "vuex";
import rules from "@/validation.js";
import ConfirmDialog from "./ConfirmDialog";

export default {
  components: {
    ConfirmDialog
  },
  props: {
    action: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    valid: true,
    rules: rules.rules,
    event: {
      pk: null,
      project: null,
      title: "",
      description: "",
      location: "",
      start_date: "",
      start_time: null,
      end_date: "",
      end_time: null
    },
    show: false,
    selectedDate: null,
    endDate: null,
    clockModal: false,
    menuStartDate: false,
    menuEndDate: false,
    menuStartTime: false,
    menuEndTime: false,
    multiDay: false,
    add: "Add Event to Calendar",
    edit: "Edit Event",
    options: {
      color: "primary",
      width: 450,
      zIndex: 200
    }
  }),
  computed: {
    ...mapState("projects", ["projects"])
  },
  methods: {
    ...mapActions("calendar", ["addEvent", "updateEvent", "deleteEvent"]),

    showAddEventForm(date) {
      this.show = true;
      this.selectedDate = date;
      this.endDate = date;
    },

    showEditForm(event) {
      this.show = true;
      this.event.pk = event.pk;
      this.event.project = event.project;
      this.event.title = event.title;
      this.event.description = event.description;
      this.event.location = event.location;
      this.event.start_time = event.start_time;
      this.event.end_time = event.end_time;
      this.selectedDate = event.start_date;
      this.endDate = event.end_date;
      this.multiDay = this.selectedDate !== this.endDate;
    },

    cancel() {
      this.$refs.form.reset();
      this.clear();
      this.show = false;
    },
    clear() {
      (this.multiDay = false),
      (this.event.project = null),
      (this.event.title = ""),
      (this.event.description = ""),
      (this.event.location = ""),
      (this.event.start_date = ""),
      (this.event.start_time = null),
      (this.event.end_date = ""),
      (this.event.end_time = null);
    },
    submit(event) {
      if (!this.$refs.form.validate()) {
        return;
      }
      event.start_date = this.selectedDate;
      event.end_date = this.endDate;
      this.addEvent(event).then(() => this.clear());
      this.show = false;
    },
    update(event) {
      if (!this.$refs.form.validate()) {
        return;
      }
      event.start_date = this.selectedDate;
      event.end_date = this.endDate;
      this.updateEvent(event).then(() => this.clear());
      this.show = false;
    },
    removeEvent(event) {
      this.$refs.confirm.showConfirmation(event);
    }
  }
};
</script>

<style scoped>
.description {
  margin-left: 0;
  margin-right: 0;
}
.event-text {
  margin-top: 2.5%;
}
</style>
